import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { CardVaultPaymentMethodDetailContent } from './CardVaultPaymentMethodDetailContent';

export async function generateStaticParams() {
    return [];
}

export default function CardVaultTransactionDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <CardVaultPaymentMethodDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
